export default __webpack_public_path__ + "static/academy-53463570264a29bf828e1708f7e275f9.png";